import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-t from-dark-900 to-dark-500 py-12 relative overflow-hidden">
      {/* Overlay decorativo */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(46,204,113,0.05),transparent_70%)] pointer-events-none"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
          <div>
            <div className="text-2xl font-semibold text-white mb-4">
              GAMA <strong className="text-primary glow-title">GAMES</strong>
            </div>
            <p className="text-grayText mb-6 max-w-md">
              "Eu transformo seu jogo em uma experiência extraordinária desde o primeiro contato."
            </p>
            <div className="flex items-start text-grayText">
              <i className="fas fa-map-marker-alt text-primary mr-2 mt-1"></i>
              <a 
                href="https://www.google.com/maps/place/Gama+Games/@-26.3347966,-48.8539287,20.75z/data=!4m15!1m8!3m7!1s0x94deb0ee898b1805:0x8a63f1f34cccea97!2sR.+Col%C3%B4mbia,+289+-+Floresta,+Joinville+-+SC,+89211-451!3b1!8m2!3d-26.3348015!4d-48.8539019!16s%2Fg%2F11c2bcz6cp!3m5!1s0x94deb18e166f5d4f:0x57d78fa8041c6d00!8m2!3d-26.3348046!4d-48.8538702!16s%2Fg%2F11jz8rtcth?entry=ttu" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
              >
                R. Colômbia, 289 - Floresta, Joinville - SC, 89211-451
              </a>
            </div>
            <div className="flex items-center text-grayText mt-3">
              <i className="fas fa-phone text-primary mr-2"></i>
              <a 
                href="https://api.whatsapp.com/send/?phone=554799089366" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
              >
                (47) 99908-9366
              </a>
            </div>
          </div>
          
          <div className="flex flex-col md:items-end">
            <h3 className="text-lg font-medium text-white mb-4 glow-title">Links Rápidos</h3>
            <nav>
              <ul className="space-y-2">
                <li>
                  <a 
                    href="#consoles" 
                    className="text-grayText hover:text-white transition-colors flex items-center"
                  >
                    <i className="fas fa-chevron-right text-xs text-primary mr-2"></i>
                    Consoles
                  </a>
                </li>
                <li>
                  <a 
                    href="#trade-process" 
                    className="text-grayText hover:text-white transition-colors flex items-center"
                  >
                    <i className="fas fa-chevron-right text-xs text-primary mr-2"></i>
                    Como Funciona a Troca
                  </a>
                </li>
                <li>
                  <a 
                    href="#gallery" 
                    className="text-grayText hover:text-white transition-colors flex items-center"
                  >
                    <i className="fas fa-chevron-right text-xs text-primary mr-2"></i>
                    Galeria de Clientes
                  </a>
                </li>
                <li>
                  <a 
                    href="#faq" 
                    className="text-grayText hover:text-white transition-colors flex items-center"
                  >
                    <i className="fas fa-chevron-right text-xs text-primary mr-2"></i>
                    Perguntas Frequentes
                  </a>
                </li>
                <li>
                  <a 
                    href="https://api.whatsapp.com/send/?phone=554799089366" 
                    className="text-grayText hover:text-white transition-colors flex items-center"
                  >
                    <i className="fas fa-chevron-right text-xs text-primary mr-2"></i>
                    Fale Comigo
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        
        <div className="pt-6 border-t border-gray-700/30 text-center">
          <p className="text-sm text-grayText">
            © {new Date().getFullYear()} GAMA GAMES. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 